module.exports = __webpack_public_path__ + "img/clase_princesa.c473fde1.webp";